module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_0.1509ecf8.png";